import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';

import { ToastProvider } from './components/ui/Toast';
import { installAnalytics } from './lib/analytics';
import { i18n } from './lib/i18n';
import { createQueryClient } from './lib/queryClient';
import { buildRouter } from './router';
import './styles/index.css';

installAnalytics();

const queryClient = createQueryClient();
const router = buildRouter(queryClient);

const container = document.getElementById('root');
if (container === null) throw new Error('Missing #root');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        {/*
         * Above the router, so the live region outlives every navigation. A toast host
         * mounted per route would be created at the same moment as the message it carries,
         * and a region that appears with its content is frequently not announced at all.
         */}
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </I18nextProvider>
    </QueryClientProvider>
  </StrictMode>,
);
